import styled, { css } from 'styled-components';
import { colors, fonts } from 'stylesheets';
import msgSent from 'assets/img/icons/message-sent.svg';
import msgRead from 'assets/img/icons/message-read.svg';

export const MessageCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: max-content;
  max-height: max-content;

  ${({ isUser }) => isUser
    && css`
      align-items: flex-end;
    `}

  ${({ isSystem }) => isSystem
    && css`
      align-items: center;
    `}

  ${ ({ last }) => last ? css`opacity: 1;` : css`opacity: 0.4;`
  }

  position: relative;
`;

export const TextWrapper = styled.div`
  width: 270px;
  padding: 10px 13px;
  border: 1px solid ${colors.greyLighter};
  border-radius: 10px;
  margin-bottom: 8px;

  background: ${({ isUser, isSystem }) => (isUser && !isSystem ? colors.alto : colors.white)};

  ${({ isUser }) => isUser
    && css`
      &:before {
        content: ' ';
        display: block;
        height: 25px;
        width: 25px;
        position: absolute;
        top: -4px;
        right: 3px;
        background-color: ${colors.alto};
        transform: rotate(-41deg) skew(50deg);
      }
    `}

  ${({ isUser, isSystem }) => !isUser
    && !isSystem
    && css`
      border-top-left-radius: 0px;
    `}

  ${({ isSystem }) => isSystem
    && css`
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    `}
`;

export const UserName = styled.p`
  text-transform: uppercase;
  color: ${colors.primary};
  font-weight: 500;
  font-size: 10px;
  margin: 0;
`;

export const MessageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const TimeHeader = styled.div`
  width: 100%;
  margin-left: 10px;
  font-family: ${fonts.primary};
  font-weight: 500;
  font-size: 11px;
`

export const BlockedContent = styled(UserName)`
  color: ${colors.greyDark};
  font-size: 11px;
  margin-bottom: 3px;
`;

export const MessageText = styled.p`
  font-size: 12px;
  color: ${colors.greyDark};
  margin: 0;
`;

export const MessageTextColor = styled.strong`
  font-size: 11px;
  font-weight: 400;
  color: ${({ color }) => color};
  margin: 0;
`;

export const ChangeDate = styled.strong`
  font-family: ${fonts.primary};
  font-weight: 500;
  font-size: 11px;
  color: ${colors.primary};
  cursor: ${ ({ last }) => last ? 'pointer' : 'not-allowed' };
`

export const MessageInfo = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
`;

export const MessageStatus = styled.span`
  width: 13px;
  height: 7px;
  background: url(${({ isRead }) => (isRead ? msgRead : msgSent)}) no-repeat;
`;

export const MessageHour = styled.span`
  font-family: ${fonts.secondary};
  font-size: 10px;
  color: ${colors.greyDark};
  display: block;
  margin: 0 5px;
`;
